import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'

import LandingHeaderActions from './LandingHeaderActions'
import { LANDING_NAV_ITEMS, isLandingNavActive } from './navigation'
import { scrollAppToTop } from '../../utils/scrollToTop'
import '../../styles/home.css'

function LandingGlobalHeader({
  loadingUser,
  userInfo,
  onOpenModal,
  onLogout,
  compactActions = false,
}) {
  const location = useLocation()
  const navigate = useNavigate()
  const [menuOpen, setMenuOpen] = useState(false)

  useEffect(() => {
    setMenuOpen(false)
  }, [location.pathname])

  const handleNavClick = () => {
    scrollAppToTop()
    setMenuOpen(false)
  }

  return (
    <header className='landing-global-header'>
      <div className='container landing-global-header-inner'>
        <button
          type='button'
          className={`landing-global-menu-toggle ${menuOpen ? 'is-open' : ''}`}
          aria-expanded={menuOpen}
          aria-controls='landing-global-nav'
          aria-label='Toggle navigation'
          onClick={() => setMenuOpen(prev => !prev)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav
          id='landing-global-nav'
          className={`landing-global-nav ${menuOpen ? 'is-open' : ''}`}
          aria-label='Primary'
        >
          {LANDING_NAV_ITEMS.map(item => (
            <Link
              key={item.to}
              to={item.to}
              className={`landing-global-nav-link ${isLandingNavActive(location.pathname, item.to) ? 'is-active' : ''}`}
              onClick={handleNavClick}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <LandingHeaderActions
          compact={compactActions}
          loadingUser={loadingUser}
          userInfo={userInfo}
          onOpenModal={onOpenModal}
          onLogout={onLogout}
          onGoToDashboard={() => navigate('/dashboard')}
        />
      </div>
    </header>
  )
}

export default LandingGlobalHeader
